import React from 'react';
import styled, { css } from 'styled-components';
import { fonts, colors } from './mixins.js';

const StyledIcon = styled.i`
  display: flex;
  align-items: center;
  width: ${(props) => props.width || '24px'};
  height: ${(props) => props.height || '24px'};
  background-size: contain;
  background-repeat: no-repeat;
  ${(props) => props.icon === 'print' && css`
    background-image: url('/Site/images/icons/order-details/print-white.svg');   
  `}
`;

const StyledButton = styled.button`
  display: flex;
  gap: 8px;
  width: ${(props) => (props.fullWidth ? '100%' : props.width || 'fit-content')};
  height: ${(props) => props.height || 'fit-content'};
  align-items: center;
  border: none;
  transition: all 0.3s ease;
  
  @media print {
    display: none !important;
  }
  
  ${(props) =>
    props.type === 'primary' &&
    css`
      display: flex;
      padding: ${(props) => (props.fullWidth ? '16px 24px' : '8px 16px')};
      justify-content: center;
      align-items: center;
      color: ${(props) => (props.disabled ? '#A8ABAF' : 'white')};
      background-color: ${(props) => (props.disabled ? '#E9E8EC' : colors.primary)};
      cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
      text-decoration: none;
      border-radius: 24px;
      opacity: ${(props) => (props.disabled ? 0.6 : 1)};
   
      &:hover:not(:disabled) {
        background-color: #502CB5;
        text-decoration: none;
      }
      
      &:disabled {
        background-color: #E9E8EC;
        color: #A8ABAF;
        cursor: not-allowed;
        pointer-events: none;
      }
    `}
    
  ${(props) =>
    props.type === 'secondary' &&
    css`
      display: flex;
      padding: ${(props) => (props.fullWidth ? '16px 24px' : '8px 16px')};
      justify-content: center;
      align-items: center;
      color: ${(props) => (props.disabled ? '#A8ABAF' : colors.primary)};
      background-color: ${(props) => (props.disabled ? '#F8F9FA' : '#FFFFFF')};
      border: 1px solid ${(props) => (props.disabled ? '#E9E8EC' : colors.primary)};
      cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
      text-decoration: none;
      border-radius: 24px;
      opacity: ${(props) => (props.disabled ? 0.6 : 1)};
   
      &:hover:not(:disabled) {
        border: 1px solid #502CB5;
        text-decoration: none;
        div {
          color: #502CB5;
        }
      }
      
      &:active:not(:disabled) {
        border: 1px solid #2F1A6B;
        text-decoration: none;
        div {
          color: #2F1A6B;
        }
      }
      
      &:disabled {
        background-color: #F8F9FA;
        color: #A8ABAF;
        border: 1px solid #E9E8EC;
        cursor: not-allowed;
        pointer-events: none;
      }
    `}
`;

const StyledText = styled.div`
  ${(props) => (props.width === '100%' ? fonts.normalTextBold() : fonts.normalTextSmallBold())}
  color: ${(props) => {
    if (props.disabled) return '#A8ABAF';
    if (props.type === "primary") return "#FFFFFF";
    return colors.primary;
  }};
  line-height: ${(props) => (props.width === '100%' ? '16px' : '14px')};
  transition: color 0.2s ease;
`;

const Button = ({ type, text, icon, url, width, height, fullWidth, onClick, disabled = false, target = "_blank" }) => {
  return (
    <StyledButton 
      type={type} 
      target={target} 
      href={url} 
      width={width} 
      height={height} 
      fullWidth={fullWidth} 
      onClick={onClick} 
      as={url ? 'a' : 'button'} 
      disabled={disabled}
    >  
      {icon && <StyledIcon icon={icon} />}
      <StyledText width={width} disabled={disabled} type={type}>
        {text}
      </StyledText>  
    </StyledButton>
  );
};

export default Button;